module.exports = __webpack_public_path__ + "img/imgdosse.ab139c4b.png";